import type { PopStoreSubscription } from '@ps/models/lib/creator-subscription';
import {
  PopStoreExtendedSubscriptionLevel,
  PopStoreSubscriptionLevel,
} from '@ps/models/lib/creator-subscription';

import { isActiveSubscription } from './access-control';

export const kOrderedExtendedSubscriptionLevels: PopStoreExtendedSubscriptionLevel[] =
  [
    PopStoreExtendedSubscriptionLevel.FOLLOWER,
    PopStoreExtendedSubscriptionLevel.SUBSCRIBER,
    PopStoreExtendedSubscriptionLevel.FAN,
    PopStoreExtendedSubscriptionLevel.VIP,
  ];

export function subscriptionLevelDisplayName(
  level: PopStoreExtendedSubscriptionLevel,
): string {
  switch (level) {
    case PopStoreExtendedSubscriptionLevel.FOLLOWER:
      return 'Followers';
    case PopStoreExtendedSubscriptionLevel.SUBSCRIBER:
      return 'Subscriber';
    case PopStoreExtendedSubscriptionLevel.FAN:
      return 'Fan';
    case PopStoreExtendedSubscriptionLevel.VIP:
      return 'VIP';
  }
}

/**
 * Resolves the human-readable name for a tier: prefers the creator's
 * custom name (when configured), then the platform display name, then
 * the level-based fallback.
 */
export function getSubscriptionDisplayName(
  subscription: PopStoreSubscription | undefined,
  level?: PopStoreExtendedSubscriptionLevel | PopStoreSubscriptionLevel,
): string {
  if (subscription && isActiveSubscription(subscription)) {
    const customName =
      subscription.subscription_data?.creator_subscription?.creator_sub_name;
    if (customName) return customName;
    if (subscription.platform_sub_level_display_name) {
      return subscription.platform_sub_level_display_name;
    }
  }

  if (level) {
    return subscriptionLevelDisplayName(
      level as PopStoreExtendedSubscriptionLevel,
    );
  }
  return 'Subscription';
}

/**
 * Comparator over the ordered enum (FOLLOWER < SUBSCRIBER < FAN < VIP).
 * `> 0` means `a` is higher than `b`.
 */
export function compareExtendedSubscriptionLevel(
  a: PopStoreExtendedSubscriptionLevel,
  b: PopStoreExtendedSubscriptionLevel,
): number {
  return (
    kOrderedExtendedSubscriptionLevels.indexOf(a) -
    kOrderedExtendedSubscriptionLevels.indexOf(b)
  );
}
